<template>
	<div class="selecting-employee-container px-3"
		:style="`color:${$appColors.primary}`"
	>
		<button type="button" class="back-arrow" @click="$emit('go-back')">
			<v-icon color="primary">keyboard_arrow_left</v-icon>
		</button>
		<h2 class="selecting-employee-title">RECURSOS HUMANOS</h2>
		<h3 class="selecting-employee-area">{{areaSelected.name}}</h3>
		<v-layout
			class="employee-row px-2"
			row justify-start align-center
			v-for="(employee, indexEmployee) in areaSelected.employees"
			:key="indexEmployee"
		>
			<v-flex xs3 class="checkbox-container">
				<v-checkbox 
					hide-details
					color="success" 
					v-model="employee.selected"
					@change="employeeSelected(employee)"
				>
				</v-checkbox>
			</v-flex>
			<v-flex xs9>
				<h3 class="employee-name"
					:style="`color:${$appColors.info}`"
				>{{employee.name}}</h3>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>

function employeeSelected(employee) {
	this.$emit('employee-selected', employee);
}

export default {
	name: 'selecting-employees',
	methods: {
		employeeSelected,
	},
	props: {
		areaSelected: {
			required: true,
			type: Object,
		},
	},
};
</script>
<style lang="scss" scoped>
.selecting-employee-container {
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	position: relative;

	.back-arrow {
		position: absolute;
		left: 10px;
		top: 0;
	}

	.selecting-employee-title {
		font-size: size(medium);
	}

	.selecting-employee-area {
		font-size: size(small);
		margin-bottom: 10px;
	}

	.employee-row {
		border-top: 1px solid color(border-gray);
		padding-bottom: 16px;
		padding-top: 16px;
		width: 100%;
	
		.checkbox-container {
			.v-input--selection-controls {
				margin-top: 0;
			}
		}
	
		.employee-name {
			font-family: font(regular);
			font-size: size(small);
		}
	}
}

</style>


// WEBPACK FOOTER //
// src/components/diagnosis/selecting-employees.vue